import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { Alert } from "../../../../theme/Component/Alert";
import { CreateEmployeeContract } from "../../../../Talentohumano/GestionTH/CreateEmployeeContract/CreateEmployeeContract";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _JobRequisition } from "../../../../../core/services/dataBean/EntityCatalog";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SCVA003 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_JobRequisition)


    const [createdContract, setCreatedContract] = useState<any>({})

    const props = configProcedure?._pocessData?.Props ?? {};
    const idLnFunctionalArea = props?.IDLnFunctionalArea ?? props?.IDLnFunctionalID;
    const contractId = props.IDContract ?? createdContract.IDContract;

    const isInvalidID = (value: any) => {
        return value === null || value === undefined || Number(value) <= 0;
    }

    useEffect(() => {
        if (props?.IDJobRequisition) {
            instance.getJobRequisition(props?.IDJobRequisition).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props?.IDJobRequisition])

    const onExportMap = (justification?: string) => {
        if (isInvalidID(contractId)) {
            toast.error("Debe crear el contrato antes de continuar");
            return;
        }

        const exportData = {
            ...createdContract,
            IDContract: contractId
        }

        instance.updateJobRequisition({ ...bean, IDContract: contractId, State: 4 }).then(
            (resp) => {
                setObs("")
                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(justification)
                }
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(exportData)
                }
                if (configProcedure?._pushProps) {
                    configProcedure?._pushProps({
                        IDContract: contractId
                    })
                }
            }
        ).catch(err => { toast.error("No se pudo realizar la accion"); console.log(err) })

    }

    const onContractCreated = (contract: any) => {
        if (isInvalidID(contract?.IDContract)) {
            toast.error("No se pudo validar el contrato creado. Intente guardar el contrato nuevamente.");
            return;
        }

        setCreatedContract(contract)

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo("Contrato creado exitosamente, ID: " + contract.IDContract);
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(contract)
        }
        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ IDContract: contract.IDContract })
        }
    }

    const [obs, setObs] = useState<string>("");

    return (
        <div className="row">
            {props.IDContract ?
                <>
                    <div className="col-md-12">
                        <Alert children={`Ya se creo el contrato con ID ${props.IDContract}`} clase="info" />
                    </div>
                    <div className="col-md-12">
                        <label>Observación</label>
                        <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton eventClick={() => { onExportMap(obs) }} icon="ri-search-line" children={'Continuar'} />
                    </div>
                </>
                :
                <>
                    <div className="col-md-12">
                        <CreateEmployeeContract isModal beanData={{
                            IDAccount: props?.IDAccountCreate,
                            IDLnFunctionalArea: idLnFunctionalArea,
                            IDAppointment: props?.IDAppointment,
                            IDEntailment: props?.IDEntailment,
                            IDEmployeeContractType: props?.IDEmployeeContractType,
                            IDEmploymentType: props?.IDEmploymentType,
                            IDPayrollType: props?.IDPayrollType
                        }} onChange={onContractCreated} />

                        <div className="col-md-12 mt-4">
                            <BasicButton disable={isInvalidID(contractId) || !bean.IDJobRequisition} eventClick={() => { onExportMap(obs) }} icon="ri-search-line" children={'Continuar'} />
                        </div>
                    </div>
                </>
            }
        </div>
    );
}
